import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import UserDateFormat from '../../components/user-date-format/index';
import { FulfillmentPlanOrderGridStatus } from '../../enums/fulfillmentplan-order-grid-status';
import FormattedCurrency from '../../components/formatted-currency/container';
import { emptyArray } from 'ui-components/default-props/empty';

import messages from './messages';
import style from './style.module.less';

const isToday = (someDate) => {
  const today = new Date();
  return (
    someDate.getDate() === today.getDate() && someDate.getMonth() === today.getMonth() && someDate.getFullYear() === today.getFullYear()
  );
};

const CustomerSummary = ({
  customerCreateDate = '',
  orderStatusCounts = emptyArray,
  totalOrderCount = 0,
  grossRevenue = 0,
  recipientName,
}) => {
  const createDate = new Date(customerCreateDate);
  const isNewCustomer = isToday(createDate);
  return (
    <div className={style.summary}>
      <div className={style['summary-header']}>
        <div>
          <div className={style.recipient}>{recipientName}</div>
          <div>
            {isNewCustomer && <FormattedMessage {...messages.newCustomer} />}
            {!isNewCustomer && (
              <FormattedMessage
                {...messages.customerSince}
                values={{
                  created: <UserDateFormat value={customerCreateDate} />,
                }}
              />
            )}
          </div>
        </div>
      </div>
      <div className={style['summary-content']}>
        {orderStatusCounts.map(({ orderStatus, count }) => (
          <div key={orderStatus} className={style['order-status-row']}>
            <span>
              <FormattedMessage {...FulfillmentPlanOrderGridStatus[orderStatus].translation} />
            </span>
            <span>{count}</span>
          </div>
        ))}
        {orderStatusCounts?.length > 0 && <div className={style.spacer} />}
        <div className={style['totals-row']}>
          <span>
            <FormattedMessage {...messages.totalOrders} />
          </span>
          <span>{totalOrderCount}</span>
        </div>
        <div className={style['totals-row']}>
          <span>
            <FormattedMessage {...messages.grossRevenue} />
          </span>
          <FormattedCurrency value={grossRevenue} />
        </div>
        {!isNewCustomer && (
          <div className={style.disclaimer}>
            <FormattedMessage {...messages.disclaimer} />
          </div>
        )}
      </div>
    </div>
  );
};

CustomerSummary.propTypes = {
  customerCreateDate: PropTypes.string,
  orderStatusCounts: PropTypes.arrayOf(
    PropTypes.shape({
      orderStatus: PropTypes.string.isRequired,
      count: PropTypes.number.isRequired,
    }),
  ),
  totalOrderCount: PropTypes.number,
  grossRevenue: PropTypes.number,
  recipientName: PropTypes.string.isRequired,
};

export default CustomerSummary;
